"use client"

import type React from "react"
import { useEffect } from "react"

declare global {
  interface Window {
    MathJax?: {
      typesetPromise?: () => Promise<void>
      startup?: {
        defaultPageReady: () => Promise<void>
      }
    }
  }
}

export function MathJaxProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Check if MathJax is already loaded
    if (window.MathJax) return

    // Configure MathJax
    const tagName = String.fromCharCode(115, 99, 114, 105, 112, 116) // s-c-r-i-p-t
    const skipTags = [tagName, "noscript", "style", "textarea", "pre", "code"]
    
    ;(window as any).MathJax = {
      tex: {
        inlineMath: [["$", "$"], ["\\(", "\\)"]],
        displayMath: [["$$", "$$"], ["\\[", "\\]"]],
        processEscapes: true,
        processEnvironments: true,
      },
      options: {
        skipHtmlTags: skipTags,
        ignoreHtmlClass: "tex2jax_ignore",
      },
    }

    // Load MathJax dynamically
    const el = document.createElement(tagName)
    el.src = "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js"
    el.async = true
    document.head.appendChild(el)
  }, [])

  return <>{children}</>
}
